import { createSlice } from '@reduxjs/toolkit';
import {
  _setNewCmpForm,
  _setCommunityBasedProvider,
  _setCounselingStaffAssigned,
  _setOracCmpDt1, 
  _setOrasCmpDt2, 
  _setOrasCmpDt3, 
  _setOrasGls1, 
  _setOrasGls2, 
  _setOrasGls3, 
  _setOrasObj1, 
  _setOrasObj2, 
  _setOrasObj3, 
  _setOrasTgtDt1,
  _setOrasTgtDt2,
  _setOrasTgtDt3,
  _setRevisionGoals1,
  _setRevisionGoals2,
  _setRevisionObjectives1,
  _setRevisionObjectives2,
  _setRevisionTargetDate1,
  _setRevisionTargetDate2,
  _setRevisionCompletedOn1,
  _setRevisionCompletedOn2,
  _setDischargeGoals1,
  _setDischargeGoals2,
  _setDischargeObjectives1,
  _setDischargeObjectives2,
  _setDischargeTargetDate1,
  _setDischargeTargetDate2,
  _setComments,
  _setParticipant1,
  _setParticipant2,
  _setParticipant3,
  _setParticipant4,
  _setParticipant5,
  _setParticipant6,
  _setCss1,
  _setCss2,
  _setCss3,
  _setCss4,
  _setCss5,
  _setCss6,
  _setScss1,
  _setScss2,
  _setScss3,
  _setScss4,
  _setScss5,
  _setScss6,
  _setRvwDate1,
  _setRvwDate2,
  _setRvwDate3,
  _setRvwDate4,
  _setRvwDate5,
  _setRvwDate6,
} from './cmpActions';
import initialState from './cmpInitialState';

export const cmpSlice = createSlice({
  name: 'getCmpForm',
  initialState,
  reducers: {
    getCmpForm: (state, action) => action.payload,
    setNewCmpForm: _setNewCmpForm,
    setCommunityBasedProvider: _setCommunityBasedProvider,
    setCounselingStaffAssigned: _setCounselingStaffAssigned,
    setOracCmpDt1: _setOracCmpDt1,
    setOrasCmpDt2: _setOrasCmpDt2,
    setOrasCmpDt3: _setOrasCmpDt3,
    setOrasGls1: _setOrasGls1,
    setOrasGls2: _setOrasGls2,
    setOrasGls3: _setOrasGls3,
    setOrasObj1: _setOrasObj1,
    setOrasObj2: _setOrasObj2,
    setOrasObj3: _setOrasObj3,
    setOrasTgtDt1: _setOrasTgtDt1,
    setOrasTgtDt2: _setOrasTgtDt2,
    setOrasTgtDt3: _setOrasTgtDt3,
    setRevisionGoals1: _setRevisionGoals1,
    setRevisionGoals2: _setRevisionGoals2,
    setRevisionObjectives1: _setRevisionObjectives1,
    setRevisionObjectives2: _setRevisionObjectives2,
    setRevisionTargetDate1: _setRevisionTargetDate1,
    setRevisionTargetDate2: _setRevisionTargetDate2,
    setRevisionCompletedOn1: _setRevisionCompletedOn1,
    setRevisionCompletedOn2: _setRevisionCompletedOn2,
    setDischargeGoals1: _setDischargeGoals1,
    setDischargeGoals2: _setDischargeGoals2,
    setDischargeObjectives1: _setDischargeObjectives1,
    setDischargeObjectives2: _setDischargeObjectives2,
    setDischargeTargetDate1: _setDischargeTargetDate1,
    setDischargeTargetDate2: _setDischargeTargetDate2,
    setComments: _setComments,
    setParticipant1: _setParticipant1,
    setParticipant2: _setParticipant2,
    setParticipant3: _setParticipant3,
    setParticipant4: _setParticipant4,
    setParticipant5: _setParticipant5,
    setParticipant6: _setParticipant6,
    setCss1: _setCss1,
    setCss2: _setCss2,
    setCss3: _setCss3,
    setCss4: _setCss4,
    setCss5: _setCss5,
    setCss6: _setCss6,
    setScss1: _setScss1,
    setScss2: _setScss2,
    setScss3: _setScss3,
    setScss4: _setScss4,
    setScss5: _setScss5,
    setScss6: _setScss6,
    setRvwDate1: _setRvwDate1,
    setRvwDate2: _setRvwDate2,
    setRvwDate3: _setRvwDate3,
    setRvwDate4: _setRvwDate4,
    setRvwDate5: _setRvwDate5,
    setRvwDate6: _setRvwDate6,
    resetCmpForm: () => initialState,
  },
});

export const {
  getCmpForm,
  setNewCmpForm,
  setCommunityBasedProvider,
  setCounselingStaffAssigned,
  setOracCmpDt1,
  setOrasCmpDt2,
  setOrasCmpDt3,
  setOrasGls1,
  setOrasGls2,
  setOrasGls3,
  setOrasObj1,
  setOrasObj2,
  setOrasObj3,
  setOrasTgtDt1,
  setOrasTgtDt2,
  setOrasTgtDt3,
  setRevisionGoals1,
  setRevisionGoals2,
  setRevisionObjectives1,
  setRevisionObjectives2,
  setRevisionTargetDate1,
  setRevisionTargetDate2,
  setRevisionCompletedOn1,
  setRevisionCompletedOn2,
  setDischargeGoals1,
  setDischargeGoals2,
  setDischargeObjectives1,
  setDischargeObjectives2,
  setDischargeTargetDate1,
  setDischargeTargetDate2,
  setComments,
  setParticipant1,
  setParticipant2,
  setParticipant3,
  setParticipant4,
  setParticipant5,
  setParticipant6,
  setCss1,
  setCss2,
  setCss3,
  setCss4,
  setCss5,
  setCss6,
  setScss1,
  setScss2,
  setScss3,
  setScss4,
  setScss5,
  setScss6,
  setRvwDate1,
  setRvwDate2,
  setRvwDate3,
  setRvwDate4,
  setRvwDate5,
  setRvwDate6,
  resetCmpForm,
} = cmpSlice.actions;

export default cmpSlice.reducer;
